import { useFlags } from 'launchdarkly-react-client-sdk';

const POINTS_BOOST_SURFACES_CONFIG_FLAG_KEY = 'fintech.incentives.points-boost-surfaces.config';

const POINTS_BOOST_SURFACE_KEYS = [
  'cart',
  'checkout',
  'homeBanner',
  'kiosk',
  'orderConfirmation',
  'productDescription',
  'signup',
] as const;

export type PointsBoostSurfacesConfig = Record<typeof POINTS_BOOST_SURFACE_KEYS[number], boolean>;

const DEFAULT_POINTS_BOOST_SURFACES_CONFIG: PointsBoostSurfacesConfig = {
  cart: false,
  checkout: false,
  homeBanner: false,
  kiosk: false,
  orderConfirmation: false,
  productDescription: false,
  signup: false,
};

// LD flag values are untyped JSON; normalize each known leaf independently so one
// malformed leaf never disables correctly typed siblings. Unknown keys are ignored.
export function normalizePointsBoostSurfacesConfig(value: unknown): PointsBoostSurfacesConfig {
  const config = { ...DEFAULT_POINTS_BOOST_SURFACES_CONFIG };
  if (value === null || typeof value !== 'object' || Array.isArray(value)) {
    return config;
  }
  const record = value as Record<string, unknown>;
  POINTS_BOOST_SURFACE_KEYS.forEach((key) => {
    const leaf = record[key];
    config[key] = typeof leaf === 'boolean' ? leaf : false;
  });
  return config;
}

export function usePointsBoostSurfacesConfig(): PointsBoostSurfacesConfig {
  const flags = useFlags();
  return normalizePointsBoostSurfacesConfig(flags[POINTS_BOOST_SURFACES_CONFIG_FLAG_KEY]);
}
